/// <reference path="include.ts" />

namespace gpx_visualizer_phase2 {

	jQuery(document).ready(():void => {
		new Application();
	});
}
